module.exports = __webpack_public_path__ + "media/headRight4.dd91131c.mp4";